import { usePagedExportFetch } from 'components/export/usePagedExportFetch';

interface Props {
  query: string,
  queryVariables: any,
  totalRecords: number,
  returnData: (data: unknown, selected?: boolean, hasError?: boolean) => void,
  exportDataKey: string,
  setCurrentPage: Function,
}

/**
 * FetchData will call api and return result of all or filtered data of table.
 *
 * Paging is shared with the other exports through usePagedExportFetch: a bounded
 * parallel pool, no Apollo cache, page count derived from the perPage actually
 * sent. Progress is reported as completed pages against the total rather than as
 * a percentage computed from the page about to be requested, which used to run
 * ahead of the work and reach 100% before the last page had come back.
 *
 * @param {Props.query} query query to be executed
 * @param {Props.queryVariables} queryVariables queryVariables contains variable for run query
 * @param {Props.totalRecords} totalRecords indicates how many records needs to be fetched from api
 * @param {Props.returnData} returnData callback to return api data
 * @param {Props.exportDataKey} exportDataKey data fetch key to retrive record
 * @param {Props.setCurrentPage} setCurrentPage receives completed and total page counts
 */

export function FetchData({ totalRecords, returnData, query, queryVariables, exportDataKey, setCurrentPage } : Props) {
  usePagedExportFetch({
    query,
    queryVariables,
    totalRecords,
    exportDataKey,
    returnData,
    onProgress: (completedPages, totalPages) => setCurrentPage(completedPages, totalPages),
  });

  return null;
};
